<app-view-title [isGreenColor]="!late" [isRedColor]="late" Title="{{ 'Intellitrailer.Rental.InFlight.Headline' | translate : 'Active rent' }}"></app-view-title>
<div class="view-content-full centered-view no-padding">
  <div class="rounded-border-card-content">
    <app-rental-box *ngIf="booking" [booking]="booking" [hasLock]="hasLock" [allowUnmanned]="allowUnmanned" (rentalAction)="recieveRentalAction($event)"></app-rental-box>
  </div>
</div> 

